import * as Sentry from "@sentry/react";
import DatabookRetry from "./pages/DatabookRetry";
import { isDatabookRetryPage } from "./lib/databookRetryToken";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { RFIProvider } from "./context/RFIContext";
import { AuthProvider } from "./hooks/useAuth";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { AppLayout } from "./components/AppLayout";
import Home from "./pages/Home";
import ProjectDetail from "./pages/ProjectDetail";
import Auth from "./pages/Auth";
import RFIGenerator from "./pages/RFIGenerator";
import RFITracker from "./pages/RFITracker";
import DemoRevisedRfi from "./pages/DemoRevisedRfi";
import DatabookBuilder from "./pages/DatabookBuilder";
import DeepResearch from "./pages/DeepResearch";
import Privacy from "./pages/Privacy";
import ArchivedProjects from "./pages/ArchivedProjects";
import VendorLanding from "./pages/vendor/VendorLanding";
import VendorRFI from "./pages/vendor/VendorRFI";
import VendorProcess from "./pages/vendor/VendorProcess";
import { VendorLayout } from "./components/vendor/VendorLayout";
import VendorPortal from "./pages/vendor/VendorPortal";

import ResetPassword from "./pages/ResetPassword";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => isDatabookRetryPage ? <DatabookRetry /> : (
  <Sentry.ErrorBoundary fallback={<p>Something went wrong.</p>}>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <RFIProvider>
          <TooltipProvider delayDuration={0}>
            <Toaster />
            <Sonner />
            <BrowserRouter>
              <Routes>
                <Route path="/auth" element={<Auth />} />
                <Route path="/auth/reset-password" element={<ResetPassword />} />
                <Route path="/vendor/*" element={<VendorPortal />} />
                <Route
                  path="/*"
                  element={
                    <ProtectedRoute>
                      <AppLayout>
                        <Routes>
                          <Route path="/" element={<Home />} />
                          <Route path="/archived" element={<ArchivedProjects />} />
                          <Route path="/project/:projectId" element={<ProjectDetail />} />
                          <Route path="/rfi" element={<RFIGenerator />} />
                          <Route path="/rfi-tracker" element={<RFITracker />} />
                          <Route path="/revised-rfi" element={import.meta.env?.VITE_DEMO_MODE === "true" ? <DemoRevisedRfi /> : <RFITracker />} />
                          <Route path="/databook-builder" element={<DatabookBuilder />} />
                          <Route path="/deep-research" element={<DeepResearch />} />
                          <Route path="/privacy" element={<Privacy />} />
                          
                          <Route path="*" element={<NotFound />} />
                        </Routes>
                      </AppLayout>
                    </ProtectedRoute>
                  }
                />
              </Routes>
            </BrowserRouter>
          </TooltipProvider>
        </RFIProvider>
      </AuthProvider>
    </QueryClientProvider>
  </Sentry.ErrorBoundary>
);

export default App;
